import React from 'react';
import { FormField } from '../../components/FormField';

interface CommercialCriteriaProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CommercialCriteria: React.FC<CommercialCriteriaProps> = ({
  formData,
  handleInputChange,
}) => {
  const criteria = [
    { name: 'hasGoodVisibility', label: 'Bonne Visibilité' },
    { name: 'isBusyStreet', label: 'Rue passante' },
    { name: 'isCommercialArea', label: 'Zone commerciale' },
    { name: 'isBusyPedestrianArea', label: 'Zone piétonne fréquentée' },
    { name: 'hasPublicTransportNearby', label: 'Proximité des transports' },
    { name: 'hasDeliveryAccess', label: 'Accès pour livraison' },
    { name: 'hasTruckAccess', label: 'Accessibilité pour camions' },
    { name: 'hasGoodShopfront', label: 'Vitrine en bon état' },
    { name: 'hasParkingNearby', label: 'Places de parking à proximité' },
    { name: 'hasCleanEnvironment', label: 'Environnement propre' },
    { name: 'isGoodCondition', label: 'Local en bon état' },
    { name: 'hasToilets', label: 'Toilettes' },
    { name: 'hasAirConditioning', label: 'Climatisation' },
    { name: 'hasHeating', label: 'Chauffage' },
    { name: 'hasKitchen', label: 'Cuisine' },
    { name: 'hasStorage', label: 'Espace de stockage' },
    { name: 'hasCistern', label: 'Citerne' },
    { name: 'hasWaterTank', label: 'Bâche à eau' },
    { name: 'hasManualShutter', label: 'Rideau manuel' },
    { name: 'hasElectricShutter', label: 'Rideau électrique' },
  ];

  return (
    <FormField label="Critères du local commercial">
      <div className="grid grid-cols-2 gap-4">
        {criteria.map(({ name, label }) => (
          <label key={name} className="flex items-center gap-2">
            <input
              type="checkbox"
              name={name}
              checked={formData[name] || false}
              onChange={handleInputChange}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </FormField>
  );
};